import { Breadcrumb,BreadcrumbItem } from "reactstrap";
import styles from  './Breadcrumb.module.scss'
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { Link, useLocation } from "react-router-dom";

export default function Breadcrumbs() {
    const breadcrumbs = useBreadcrumbs();
    const location = useLocation();
 
  return (
    <Breadcrumb>
        {
            breadcrumbs &&
                breadcrumbs.map(({match,breadcrumb}) => (
                    <BreadcrumbItem className={`${styles.lgtBreadcrumb}`} key={breadcrumb.props.children}>
                        <Link 
                            to={match.pathname}
                            className={`${match.pathname === location.pathname ? styles.active : ''}`}
                            >
                            {
                                match.pathname === '/' && <i className='bi bi-house'></i>
                            }
                            {match.pathname === '/' ? '' : breadcrumb}
                        </Link>
                    </BreadcrumbItem>
                    
                    ))
            
        }
  </Breadcrumb>
  )
}
